import React from 'react';
import { styled } from '@compiled/react';

import { token } from '@atlaskit/tokens';
import { Box, xcss } from '@atlaskit/primitives';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const ContentTypesHeaderContainer = styled.div<{ isFloating?: boolean }>({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	position: (props) => {
		return props.isFloating ? 'absolute' : 'relative';
	},
	background: 'transparent',
	pointerEvents: 'none',
	width: '100%',
	display: 'grid',
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const FlexNavigationContainer = styled.div({
	alignItems: 'flex-start',
	display: 'flex',
	flexDirection: 'row',
	flexWrap: 'nowrap',
	padding: `${token('space.050', '4px')} ${token(
		'space.150',
		'12px',
	)}` /* This is temporary for release 3 so that the left side of the header aligns with Fabric's right side  */,
	boxSizing: 'border-box',
	justifyContent: 'space-between',
});

const titleAndBreadcrumbsBaseStyles = xcss({
	pointerEvents: 'auto',
	backgroundColor: 'elevation.surface',
	borderRadius: '3px',
});

// Utilized only when the content header is pinned and during the viewing of public whiteboards
const alignCenterStyle = xcss({
	alignSelf: 'center',
});

export const TitleAndBreadcrumbsWrapper = ({
	isContentHeaderPinned = false,
	children,
}: {
	isContentHeaderPinned?: boolean;
	children: React.ReactNode;
}) => {
	return (
		<Box
			paddingBlockStart="space.100"
			paddingInline="space.100"
			paddingBlockEnd="space.050"
			xcss={[titleAndBreadcrumbsBaseStyles, isContentHeaderPinned && alignCenterStyle]}
		>
			{children}
		</Box>
	);
};
